import React, { useState, useEffect } from 'react';
import { SEO } from '../components/SEO';
import { GalleryLightbox } from '../components/GalleryLightbox';

export function GalleryPage() {
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    async function fetchGallery() {
      try {
        const res = await fetch('https://api.dev.auxo.dk/public/v2/content/galleri?url_slug=hovedgalleri');
        if (res.ok) {
          const data = await res.json();
          if (data.items && data.items.length > 0) {
            setGallery(data.items[0]);
          }
        }
      } catch (err) {
        console.error('Error loading gallery from CMS:', err);
      } finally {
        setLoading(false);
      }
    }
    fetchGallery();
  }, []);

  const images = gallery?.images || [];

  return (
    <>
      <SEO
        title="Galleri | KELFAE LOFTER ApS"
        description="Se eksempler på udvalgte akustiklofter, flådelofter, gitterlofter og T-skinne løsninger monteret hos professionelle kunder."
      />

      <section className="bg-neutral-100 border-b border-neutral-200 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-900 bg-[#7FDCA7]/30 px-3 py-1 rounded-full border border-[#7FDCA7]/50 inline-block">
              Inspiration & Referencer
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-neutral-900 font-serif-heading tracking-tight">
              Vores Galleri
            </h1>
            <p className="text-sm sm:text-base text-neutral-600 leading-relaxed">
              Stort program af akustiklofter fra førende producenter. Der stilles høje krav til efterklangstiden i kontorlokaler, undervisningslokaler og storkøkkener samt alle andre store og åbne rum. Se noget af vores arbejde nedenfor.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 bg-white min-h-[60vh]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="py-20 text-center text-neutral-500 text-sm">
              <i className="fa-solid fa-spinner fa-spin mr-2 text-[#7FDCA7]" aria-hidden="true" />
              Henter billedgalleri fra CMS...
            </div>
          ) : images.length === 0 ? (
            <div className="py-16 text-center text-neutral-500 text-sm">
              Ingen galleribilleder fundet.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {images.map((imgUrl, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    setLightboxIndex(idx);
                    setLightboxOpen(true);
                  }}
                  className="group relative bg-white border border-neutral-200 rounded-2xl overflow-hidden cursor-pointer h-64 sm:h-72 shadow-sm hover:border-[#7FDCA7] hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                >
                  <img
                    src={imgUrl}
                    alt={`Galleribillede ${idx + 1}`}
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                    <span className="text-[#7FDCA7] text-xs font-semibold flex items-center gap-2">
                      <i className="fa-solid fa-magnifying-glass-plus" aria-hidden="true" />
                      <span>Klik for at forstørre</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {lightboxOpen && (
        <GalleryLightbox
          images={images}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
}
